import React, { Component } from "react";
import { Link } from "react-router-dom";
import mls from "../../../app/assets/images/banner/mls.png";
import cost from "../../../app/assets/images/banner/cost01.png";
import access from "../../../app/assets/images/banner/access01.png";
import knowledge from "../../../app/assets/images/banner/knowledge01.png";
class CourseGridPopular extends Component {
  constructor(props) {
    super(props);
    this.state = {
      coursePopular: [
        {
          id: 1,
          price: "$200 ",
          review: "4.5 ",
          reviewCount: "40",
          duration: "6.5",
          lessons: "97 ",
          img: "assets/images/course/img_01.jpg",
          title: "SQL-Data Analysis: Crash Course",
        },
        {
          id: 2,
          review: "4.5 ",
          reviewCount: "40",
          duration: "6.5",
          lessons: "97 ",
          img: "assets/images/course/img_05.jpg",
          title: "Learn How to Start an Amazon FBA Store",
        },
        {
          id: 3,
          price: "$450",
          review: "4.5 ",
          reviewCount: "40",
          duration: "6.5",
          lessons: "97 ",
          img: "assets/images/course/img_03.jpg",
          title: "Emotional Intelligence at Work: Learn Emotions",
        },
        {
          id: 4,
          price: "$250",
          review: "4.5 ",
          reviewCount: "40",
          duration: "6.5",
          lessons: "97 ",
          img: "assets/images/course/img_02.jpg",
          title: " Competitive Strategy law & Organization",
        },
      ],
    };
  }
  render() {
    return (
      //Course style 1
      <section className="course-wrapper section-padding bg-light">
        <div className="container custom-cn-width">
          <div class="row g-lg-5 g-4 align-items-center justify-content-center text-center">
            <div class="col-lg-9">
              <h1 class="fw-light mb-lg-5 mb-4">
                CAP Digisoft Solutions provides a comprehensive selection of
                services under several brands.
              </h1>
            </div>
          </div>

          <div class="row justify-content-center g-lg-5 g-4">
            <div class="col-xl-11 col-lg-12">
              <div class="border-inner">
                <div
                  className="ms-logo-wrapper text-center"
                  style={{ padding: "10px 30px" }}
                >
                  <img src={mls} alt="Logo" class="img-fluid mb-1" />
                </div>
                <div className="p-lg-5 pt-0 p-4 b-r-b-10">
                  <div class="row text-center justify-content-center">
                    <div class="col-lg-11 px-lg-4">
                      <h2 class="fw-medium font-size-32 mb-3 text-dark">
                        A Medical Record Summary Solution
                      </h2>
                      <h5 class="h5 mb-xl-5 font-size-21 mb-4 fw-400 text-dark">
                        Medical Legal Spider takes raw, unorganized medical
                        records and gives you an easy to use, organized medical
                        file or factual summary in the exact format that works
                        best for your firm.
                      </h5>
                    </div>
                  </div>
                  <div class="row justify-content-center mb-lg-4 g-4 text-center text-xl-start">
                    <div class="col-lg-4 col-md-6">
                      <div class="feature-box d-xl-flex">
                        <div>
                          <div class="icon sec-primary-ic">
                            <img src={cost} alt="Logo" class="img-fluid mb-1" />
                          </div>
                        </div>
                        <div class="ms-xl-4 mt-4 mt-xl-0">
                          <h4 class="mb-3 font-size-25 text-dark">
                            Lower Costs.
                          </h4>
                          <p className="font-size-17 mb-0 text-dark">
                            Lower your cost by as much as 40%, while shifting
                            overhead to a billable file expense. Plus, you will
                            know your medical record preparation costs in
                            advance and stay fee-competitive.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                      <div class="feature-box d-xl-flex">
                        <div>
                          <div class="icon sec-primary-ic">
                            <img
                              src={access}
                              alt="Logo"
                              class="img-fluid mb-1"
                            />
                          </div>
                        </div>
                        <div class="ms-xl-4 mt-4 mt-xl-0">
                          <h4 class="mb-3 font-size-25 text-dark">
                            Ease of Access.
                          </h4>
                          <p className="font-size-17 mb-0 text-dark">
                            Have a complete and easy to access reference to all
                            relevant medical events for settlement analysis,
                            expert review, deposition, mediation and trial and
                            free up skilled staff for more important tasks.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                      <div class="feature-box d-xl-flex">
                        <div>
                          <div class="icon sec-primary-ic">
                            <img
                              src={knowledge}
                              alt="Logo"
                              class="img-fluid mb-1"
                            />
                          </div>
                        </div>
                        <div class="ms-xl-4 mt-4 mt-xl-0">
                          <h4 class="mb-3 font-size-25 text-dark">
                            Increased Knowledge.
                          </h4>
                          <p className="font-size-17 mb-0 text-dark">
                            Increase full knowledge of all salient medical
                            aspects of your case. Improve screening for merit,
                            identify problem cases earlier and more accurately
                            determine settlement values.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-center">
                    <h3 class="mb-3 mt-4 mt-lg-3">Highlights</h3>
                    <div class="row g-0 line-box-3">
                      <div class="col-lg-4 col-md-6">
                        <div class="">
                          <h5 class="px-xl-4 fw-light">
                            eSorting, Medical Indexing and Categorizing
                          </h5>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6">
                        <div class="">
                          <h5 class="px-xl-5 fw-light">
                            Narrative Medical Record Summaries
                          </h5>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6">
                        <div class="">
                          <h5 class="px-xl-5 fw-light">
                            Identifying Missing Medical Records
                          </h5>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6">
                        <div class="">
                          <h5 class="px-xl-5 fw-light">
                            Data Extraction and Customized Support
                          </h5>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6">
                        <div class="">
                          <h5 class="px-xl-5 fw-light">
                            Deliverables &amp; File Navigating
                          </h5>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6">
                        <div class="">
                          <h5 class="px-xl-5 fw-light">
                            Specialty Medical Record Services
                          </h5>
                        </div>
                      </div>
                    </div>
                    <a
                      class="btn cust-btn-primary secondary-main mt-4"
                      href="/#"
                    >
                      Visit site
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default CourseGridPopular;
